
import Quickadd from './quickadd.vue'
import { parseProductFromShopify } from '~/helpers/shopify/product'
import ProductTester from '~/helpers/shopify/tests'
import Price from '@/components/price/price'
import LolePicture from '@/components/picture/lole-picture'
export default {
  components: { Price, LolePicture, Quickadd },
  props: {
    wording: {
      type: Object,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      videoOnError: false,
      products: [],
    }
  },
  computed: {
    pairWithIsActive() {
      return this.wording?.bundle_isActive
    },
  },
  beforeMount() {
    this.fetchProducts()
  },
  methods: {
    async fetchProducts() {
      try {
        const parsedIds = this.parseIds()
        if (parsedIds.length > 0) {
          const ids = this.getProducts(parsedIds)
          const { data } = await this.$shopify.product.retrieveProducts(ids)
          if (data.errors) throw new Error(JSON.stringify(data.errors))
          else if (data?.data?.nodes?.length > 0) {
            data.data.nodes.forEach((product, index) => {
              if (product) {
                const test = new ProductTester(
                  product,
                  parsedIds[index].color,
                  this.$i18n.locale
                )
                if (
                  product &&
                  test.productExist() &&
                  test.colorExist() &&
                  test.metafieldsExist() &&
                  test.metafieldsLangExist() &&
                  test.metafieldsColorExist()
                ) {
                  this.products.push(
                    parseProductFromShopify(
                      product,
                      this.$i18n.locale,
                      parsedIds[index].color
                    ).result
                  )
                }
              }
            })
          }
        }
      } catch (e) {
        this.$sentryException(e, {
          source: 'Homepage',
          level: 'fatal',
          extra: `Bundle PDP - fetchProducts() fail : ${e}`,
        })
      }
    },
    parseIds() {
      try {
        const ret = []
        const productsBundle = this.wording.bundle_products.filter((x) => {
          return (
            x.handleProduct === this.product.handleShopify &&
            x.color === this.product.internal_color_code
          )
        })
        if (productsBundle.length > 0) {
          productsBundle[0].products.forEach((product) => {
            ret.push({
              id: `gid://shopify/Product/${product.id}`,
              color: product.color_code,
            })
          })
        }
        return ret
      } catch (e) {
        this.$sentryException(e, {
          source: 'Homepage',
          level: 'fatal',
          extra: `Bundle PDP - parseIds() : ${e}`,
        })
        return []
      }
    },
    getProducts(ids) {
      if (ids.length === 0) return null
      const ret = []
      ids.forEach(({ id }) => {
        ret.push(id)
      })
      return ret
    },
    getSecondMediaTypeImage(product) {
      if (product.medias && product.medias.length > 0) {
        const images = product.medias.filter((media) => {
          return media.type === 'image'
        })
        return images[1]
      }
    },
  },
}
